<template>
    <div v-show="showMenu"
         class="parameter-hint-popup-wrapper"
         :style="{ left: x + 'px', top: y + 'px' }">
        <div class="parameter-hint-popup">
            <div v-html="rawHtml"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'flow-v2-rich-tooltip',
        data() {
            return {
                x: 0,
                y: 0,
                showMenu: false,
                rawHtml: null,
            }
        },
        props: {
        },
        computed: {
        },
        methods: {
            showPopup(html, x, y) {
                this.x = x;
                this.y = y;
                this.rawHtml = html;
                this.showMenu = true;
            },
            hidePopup() {
                this.showMenu = false;
            },
        }
    };
</script>
<style scoped>
    .parameter-hint-popup-wrapper {
        position: fixed;
        z-index: 9999;
        pointer-events: none;
    }
    .parameter-hint-popup {
        background: linear-gradient(180deg, #fff 0%, #eee 100%);
        border: 1px solid #555;
        border-radius: 8px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.45);
        color: #222;
        font-size: 12px;
        line-height: 1.4;
        padding: 8px 10px;
        min-width: 320px;
        max-width: 680px;
        xuser-select: none;
    }
</style>
